import PropTypes from "prop-types";

import PageViewTrigger from "@/base/PageViewTrigger/PageViewTrigger";
import useConsentPersistenceCheck from "@/datagrailIntegration/useConsentPersistenceCheck";
import useStudentConsentSuppression from "@/datagrailIntegration/useStudentConsentSuppression";
import useStorageAccess from "@/embedIntegration/useStorageAccess";
import PendoTrackingContainer from "@/pendoIntegration/PendoTrackingContainer";
import BrowserLogging from "@/monitoring/BrowserLogging";
import RUMTracking from "@/monitoring/RUMTracking";
import GoogleTagManagerScript from "@/gtmIntegration/GoogleTagManagerScript/GoogleTagManagerScript";
import GlobalEventsHandler from "./GlobalEventsHandler/GlobalEventsHandler";

/**
 * Creates a wrapper which is meant to be rendered before every "page" of the application.
 * Elements should if possible be rendered as siblings to avoid potentially unnecessary rerenders of the children element
 * @param {node} children - Wrapped pages.
 */

const AllPagesWrapper = ({ children }) => {
  // Programmatically set essential-only consent for student users so the
  // DataGrail banner never appears and analytics stay off for them.
  useStudentConsentSuppression();
  // Inside a cross-site LMS frame, ask for storage access so DataGrail's consent
  // cookie can persist in browsers that block third-party storage outright.
  useStorageAccess();
  // Report to Datadog if a consent choice still fails to persist, so the cookie
  // shim cannot silently stop working and bring the banner loop back.
  useConsentPersistenceCheck();

  return (
    <>
      <RUMTracking />
      <BrowserLogging />
      <GoogleTagManagerScript />
      <GlobalEventsHandler />
      <PageViewTrigger />
      <PendoTrackingContainer />
      {children}
    </>
  );
};

AllPagesWrapper.propTypes = {
  children: PropTypes.node,
};

export default AllPagesWrapper;
